// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/feed/components/FeedCategoryIcon.module.css';
import {feedCategoryIcon} from '@app/features/feed/utils/FeedCategoryIconUtils';
import {clsx} from 'clsx';

interface FeedCategoryIconProps {
	emoji: string;
	// The neutral square behind the icon, sized by the surface's className.
	tile?: boolean;
	className?: string;
	'data-flx'?: string;
}

// Micup akis-kategori: the mark of a category on every topic surface. A known emoji is drawn as a line icon in the
// text colour, the size following the font size; any other emoji is drawn as it is. Plain markup, nothing measured or
// moving.
export const FeedCategoryIcon = ({emoji, tile = false, className, 'data-flx': dataFlx}: FeedCategoryIconProps) => {
	const Icon = feedCategoryIcon(emoji);
	return (
		<span
			className={clsx(styles.icon, tile && styles.tile, className)}
			aria-hidden
			data-flx={dataFlx ?? 'feed.feed-category-icon.icon'}
		>
			{Icon ? <Icon weight="regular" className={styles.glyph} data-flx="feed.feed-category-icon.glyph" /> : emoji}
		</span>
	);
};
